import React, { FC, useEffect } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';

import { Dispatch, iRootState } from '../../../../../../store';
import { useAsync } from '../../../../../../hooks';

import Spinner from '../../../../../../components_/Spinner';

import Card from './Card';
import Attributes from './Attributes';

const mapState = (state: iRootState) => ({
  item: state.infrastructureBeacons.item,
  isGeo: state.infrastructureMap.layers.isGeo
});

const mapDispatch = (dispatch: any) => {
  const d = dispatch as Dispatch;

  return {
    getItem: d.infrastructureBeacons.getItem,
    reset: d.infrastructureBeacons.reset,
    setMarkerEditMode: d.infrastructureMap.setMarkerEditMode
  };
};

type connectedProps = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>;

type IProps = connectedProps;

interface IParams {
  mac: string;
}

const AreaShow: FC<IProps> = ({ item, getItem, reset, setMarkerEditMode, isGeo }) => {
  const { mac } = useParams<IParams>();
  const [runGetItem, isLoadingGetItem, isGetItemLoadingError] = useAsync(getItem);

  useEffect(() => {
    return () => {
      reset();
    };
  }, []);

  useEffect(() => {
    runGetItem(mac);
  }, [mac]);

  const isLoading = isLoadingGetItem;
  const isLoadingError = isGetItemLoadingError;

  return (
    <>
      {isLoading && <Spinner />}
      {!isLoading && item && (
        <>
          <Card item={item} setMarkerEditMode={setMarkerEditMode} />
          <Attributes item={item} isGeo={isGeo} />
        </>
      )}
    </>
  );
};

const withConnect = connect(mapState, mapDispatch);

export default withConnect(AreaShow);
